import { IUserSummary } from '../../types/global/helper';

// Mock user for current user
export const currentUser: IUserSummary = {
    _id: 'current-user-id',
    id: 'current-user-id',
    firstName: 'John',
    lastName: 'Doe',
    userName: 'johndoe',
    profile_picture: 'https://i.pravatar.cc/150?img=1',
    verified: true,
    role: 'user',
    audme_profile: '',
};

// Mock participants
export const mockParticipants: IUserSummary[] = [
    {
        _id: 'user1',
        id: 'user1',
        firstName: 'Alice',
        lastName: 'Johnson',
        userName: 'alicej',
        profile_picture: 'https://i.pravatar.cc/150?img=5',
        verified: true,
        role: 'user',
        audme_profile: '',
    },
    {
        _id: 'user2',
        id: 'user2',
        firstName: 'Bob',
        lastName: 'Smith',
        userName: 'bobsmith',
        profile_picture: 'https://i.pravatar.cc/150?img=7',
        verified: false,
        role: 'user',
        audme_profile: '',
    },
    {
        _id: 'user3',
        id: 'user3',
        firstName: 'Claire',
        lastName: 'Williams',
        userName: 'clairew',
        profile_picture: 'https://i.pravatar.cc/150?img=9',
        verified: true,
        role: 'user',
        audme_profile: '',
    },
    {
        _id: 'user4',
        id: 'user4',
        firstName: 'David',
        lastName: 'Brown',
        userName: 'davidb',
        profile_picture: 'https://i.pravatar.cc/150?img=11',
        verified: false,
        role: 'user',
        audme_profile: '',
    },
    {
        _id: 'user5',
        id: 'user5',
        firstName: 'Emma',
        lastName: 'Davis',
        userName: 'emmad',
        profile_picture: 'https://i.pravatar.cc/150?img=3',
        verified: true,
        role: 'user',
        audme_profile: '',
    },
];

// Mock rooms
export const mockRooms = [
    {
        _id: 'room1',
        participants: [currentUser, mockParticipants[0]],
        unread_count: 3,
        created_at: new Date(2023, 9, 15),
        last_message: {
            _id: 'msg1_last',
            room: { _id: 'room1' },
            message_content: 'Hey, how are you doing?',
            created_at: new Date(2023, 9, 15, 14, 30),
            created_by: mockParticipants[0],
            received: true,
            is_reply: false,
            message_type: 'chat',
        },
    },
    {
        _id: 'room2',
        participants: [currentUser, mockParticipants[1]],
        unread_count: 0,
        created_at: new Date(2023, 9, 14),
        last_message: {
            _id: 'msg2_last',
            room: { _id: 'room2' },
            message_content: 'Thanks for the information!',
            created_at: new Date(2023, 9, 14, 10, 15),
            created_by: currentUser,
            received: true,
            is_reply: false,
            message_type: 'chat',
        },
    },
    {
        _id: 'room3',
        participants: [currentUser, mockParticipants[2]],
        unread_count: 1,
        created_at: new Date(2023, 9, 13),
        last_message: {
            _id: 'msg3_last',
            room: { _id: 'room3' },
            message_content: 'Can we schedule a meeting tomorrow?',
            created_at: new Date(2023, 9, 13, 16, 45),
            created_by: mockParticipants[2],
            received: false,
            is_reply: false,
            message_type: 'chat',
        },
    },
    {
        _id: 'room4',
        participants: [currentUser, mockParticipants[3], mockParticipants[4]],
        unread_count: 5,
        created_at: new Date(2023, 9, 10),
        last_message: {
            _id: 'msg4_last',
            room: { _id: 'room4' },
            message_content: "Let's discuss the project requirements",
            created_at: new Date(2023, 9, 10, 9, 0),
            created_by: mockParticipants[3],
            received: false,
            is_reply: false,
            message_type: 'chat',
        },
    },
];

// Mock messages for each room
export const mockMessages = {
    room1: [
        {
            _id: 'msg1_1',
            room: { _id: 'room1' },
            message_content: 'Hi there!',
            created_at: new Date(2023, 9, 15, 14, 0),
            created_by: currentUser,
            received: true,
            is_reply: false,
            message_type: 'chat',
        },
        {
            _id: 'msg1_2',
            room: { _id: 'room1' },
            message_content: 'Hello! How can I help you today?',
            created_at: new Date(2023, 9, 15, 14, 15),
            created_by: mockParticipants[0],
            received: true,
            is_reply: false,
            message_type: 'chat',
        },
        {
            _id: 'msg1_3',
            room: { _id: 'room1' },
            message_content: 'I had a question about the upcoming audition.',
            created_at: new Date(2023, 9, 15, 14, 20),
            created_by: currentUser,
            received: true,
            is_reply: false,
            message_type: 'chat',
        },
        {
            _id: 'msg1_last',
            room: { _id: 'room1' },
            message_content: 'Hey, how are you doing?',
            created_at: new Date(2023, 9, 15, 14, 30),
            created_by: mockParticipants[0],
            received: true,
            is_reply: false,
            message_type: 'chat',
        },
    ],
    room2: [
        {
            _id: 'msg2_1',
            room: { _id: 'room2' },
            message_content: 'Hello Bob, I wanted to talk about the recent project.',
            created_at: new Date(2023, 9, 14, 9, 30),
            created_by: currentUser,
            received: true,
            is_reply: false,
            message_type: 'chat',
        },
        {
            _id: 'msg2_2',
            room: { _id: 'room2' },
            message_content: 'Sure, what would you like to know?',
            created_at: new Date(2023, 9, 14, 9, 45),
            created_by: mockParticipants[1],
            received: true,
            is_reply: false,
            message_type: 'chat',
        },
        {
            _id: 'msg2_3',
            room: { _id: 'room2' },
            message_content: 'I need the details about the shooting schedule.',
            created_at: new Date(2023, 9, 14, 10, 0),
            created_by: currentUser,
            received: true,
            is_reply: false,
            message_type: 'chat',
        },
        {
            _id: 'msg2_4',
            room: { _id: 'room2' },
            message_content: "We'll be shooting from Nov 10-15. I'll send you the detailed schedule later today.",
            created_at: new Date(2023, 9, 14, 10, 10),
            created_by: mockParticipants[1],
            received: true,
            is_reply: false,
            message_type: 'chat',
        },
        {
            _id: 'msg2_last',
            room: { _id: 'room2' },
            message_content: 'Thanks for the information!',
            created_at: new Date(2023, 9, 14, 10, 15),
            created_by: currentUser,
            received: true,
            is_reply: false,
            message_type: 'chat',
        },
    ],
    room3: [
        {
            _id: 'msg3_1',
            room: { _id: 'room3' },
            message_content: 'Hi Claire, are you available for a meeting?',
            created_at: new Date(2023, 9, 13, 15, 0),
            created_by: currentUser,
            received: true,
            is_reply: false,
            message_type: 'chat',
        },
        {
            _id: 'msg3_2',
            room: { _id: 'room3' },
            message_content: 'Hi! What time works for you?',
            created_at: new Date(2023, 9, 13, 16, 0),
            created_by: mockParticipants[2],
            received: true,
            is_reply: false,
            message_type: 'chat',
        },
        {
            _id: 'msg3_3',
            room: { _id: 'room3' },
            message_content: 'How about tomorrow at 2pm?',
            created_at: new Date(2023, 9, 13, 16, 30),
            created_by: currentUser,
            received: true,
            is_reply: false,
            message_type: 'chat',
        },
        {
            _id: 'msg3_last',
            room: { _id: 'room3' },
            message_content: 'Can we schedule a meeting tomorrow?',
            created_at: new Date(2023, 9, 13, 16, 45),
            created_by: mockParticipants[2],
            received: false,
            is_reply: false,
            message_type: 'chat',
        },
    ],
    room4: [
        {
            _id: 'msg4_1',
            room: { _id: 'room4' },
            message_content: "Hey team, let's coordinate on the new project.",
            created_at: new Date(2023, 9, 10, 8, 0),
            created_by: currentUser,
            received: true,
            is_reply: false,
            message_type: 'chat',
        },
        {
            _id: 'msg4_2',
            room: { _id: 'room4' },
            message_content: "I'm available. What's the agenda?",
            created_at: new Date(2023, 9, 10, 8, 15),
            created_by: mockParticipants[3],
            received: true,
            is_reply: false,
            message_type: 'chat',
        },
        {
            _id: 'msg4_3',
            room: { _id: 'room4' },
            message_content: 'I can join as well. Do we have a brief?',
            created_at: new Date(2023, 9, 10, 8, 30),
            created_by: mockParticipants[4],
            received: true,
            is_reply: false,
            message_type: 'chat',
        },
        {
            _id: 'msg4_4',
            room: { _id: 'room4' },
            message_content: "Yes, I'll prepare a document with requirements.",
            created_at: new Date(2023, 9, 10, 8, 45),
            created_by: currentUser,
            received: true,
            is_reply: false,
            message_type: 'chat',
        },
        {
            _id: 'msg4_last',
            room: { _id: 'room4' },
            message_content: "Let's discuss the project requirements",
            created_at: new Date(2023, 9, 10, 9, 0),
            created_by: mockParticipants[3],
            received: false,
            is_reply: false,
            message_type: 'chat',
        },
    ],
};
